import React, { useState } from 'react';
import { useParams } from "react-router-dom";

import { useForm } from 'react-hook-form';

import InnerPage from "../components/layout/InnerPage";

import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';

import './ResetPassword.css';
import {useAuth} from "../contexts/AuthContext";

const ResetPassword = () => {

  const { resetPassword, loading } = useAuth();
  const { token } = useParams();
  const [passwordChanged, setPasswordChanged] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    clearErrors
  } = useForm();

  const password = watch('password');

  const onSubmit = async (data) => {
    clearErrors();

    const result = await resetPassword(data.password, token);

    console.log(result);

    if (result.success) {
      setPasswordChanged(true);
    } else {
      setError('root', {
        type: 'manual',
        message: result.error
      });
    }
  };

  if (passwordChanged) {
    return (
      <InnerPage title="Reset Password">
        <div className="reset-password-container">
          <Card
            className="auth-card"
            title="Password Changed"
          >
            <div className="auth-alert auth-alert-success">
              <div>
                <strong>Password has been reset successfully!</strong>
                <p>Please login with your new password.</p>
              </div>
            </div>
          </Card>
        </div>
      </InnerPage>
   );
  }

  return (
    <InnerPage title="Reset Password">
      <div className="reset-password-container">
        <Card
          title="Set a New Password"
          className="card-no-padding"
        >

          {errors.root && (
            <div className="auth-alert auth-alert-error">
              <span>❌</span>
              <div>
                <strong>Request failed</strong>
                <p dangerouslySetInnerHTML={{__html: errors.root.message}}></p>
              </div>
            </div>
          )}

          <form className="one-column-form white-form" onSubmit={handleSubmit(onSubmit)}>
            <Input
              label="New Password"
              type="password"
              placeholder="Enter your password"
              required
              error={errors.password?.message}
              {...register('password', {
                required: 'Password is required'
              })}
            />

            <Input
              label="Confirm New Password"
              type="password"
              placeholder="Confirm your password"
              required
              error={errors.confirm_password?.message}
              {...register('confirm_password', { validate: val => val === password || 'Passwords do not match' })}
            />

            <Button
              type="submit"
              variant="primary"
              size="large"
              fullWidth
              loading={loading}
              disabled={loading}
            >
              Set a New Password
            </Button>
          </form>
        </Card>
      </div>
    </InnerPage>
);
};

export default ResetPassword;